import { render, staticRenderFns } from "./versionIntroduction.vue?vue&type=template&id=f41e4774&scoped=true&"
import script from "./versionIntroduction.vue?vue&type=script&lang=js&"
export * from "./versionIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./versionIntroduction.vue?vue&type=style&index=0&id=f41e4774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41e4774",
  null
  
)

export default component.exports